module.exports = __webpack_public_path__ + "static/media/construction.c937f3bb.svg";